import React from "react"
import { Stack, styled } from "@mui/material"
import CheckIcon from "@mui/icons-material/Check"
import CloseIcon from "@mui/icons-material/Close"
import { COLORS } from "../../../../utils"
import { StyledIcon } from "../../../Settings/TechnicalSheet/Resources/reusableSteps/ReusableStepFormRow"

export const sx = {
	checkIcon: {
		color: COLORS.GREEN_800,
		cursor: "pointer"
	},
	closeIcon: {
		color: COLORS.RED_900,
		cursor: "pointer"
	}
}

const StyledIconButton = styled("button")({
	all: "unset",
	cursor: "pointer",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	width: 32,
	height: 32,
	padding: 4,
	borderRadius: 4,
	color: COLORS.PRODUCTION_RECEPTION_COLOR,
	border: `1px solid ${COLORS.PRIMARY_BLUE_200}`,
	backgroundColor: "#F0F9FF",
	"&:hover": {
		backgroundColor: COLORS.PRIMARY_BLUE_20,
	},
	"&.checkIcon": {
		border: `1px solid ${COLORS.GREEN_SUCCESS_300}`,
		backgroundColor: COLORS.GREEN_SUCCESS_50,
	},
	"&:hover.checkIcon": {
		backgroundColor: COLORS.GREEN_SUCCESS_50 + "40",
	},
	"&.closeIcon": {
		border: `1px solid ${COLORS.RED_900}`,
		backgroundColor: COLORS.RED_50,
	}, "&:hover.closeIcon": {
		backgroundColor: COLORS.RED_900 + "40",
	},
})

const PSEToggleFormButtons = ({
	isEdition = false,
	onSubmit,
	onClose,
	onOpen
}) => {
	return (
		<div>
			{isEdition
				? (
					<Stack direction="row" spacing={1.5}>
						<StyledIconButton onClick={onSubmit} className="checkIcon">
							<CheckIcon sx={sx.checkIcon} />
						</StyledIconButton>
						<StyledIconButton onClick={onClose} className="closeIcon">
							<CloseIcon sx={sx.closeIcon} />
						</StyledIconButton>
					</Stack>
				) : (
					<StyledIconButton onClick={onOpen} sx={{ width: 32, height: 32 }}>
						<StyledIcon isEdition={isEdition} alt="chevron" src="/icons/edit-outlined-blue.svg" />
					</StyledIconButton>
				)}
		</div>
	)

}

export default PSEToggleFormButtons
